export const DASHBOARD_ASSET_METADATA = {
  BTC: { name: 'Bitcoin', code: 'BTC', digits: 4 },
  ETH: { name: 'Ethereum', code: 'ETH', digits: 4 },
  USDC: { name: 'USD Coin', code: 'USDC', digits: 4 },
  USDT: { name: 'Tether', code: 'USDT', digits: 4 },
  USDE: { name: 'Ethena USDe', code: 'USDE', digits: 4 },
  USYC: { name: 'Hashnote USYC', code: 'USYC', digits: 4 },
  XRP: { name: 'XRP', code: 'XRP', digits: 4 },
  STETH: { name: 'Lido Staked Ether', code: 'STETH', digits: 4 },
  SOL: { name: 'Solana', code: 'SOL', digits: 4 },
  PAXG: { name: 'PAX Gold', code: 'PAXG', digits: 4 },
  MATIC: { name: 'Polygon', code: 'MATIC', digits: 4 },
  EURR: { name: 'EURR', code: 'EURR', digits: 4 },
  BUIDL: { name: 'BUIDL', code: 'BUIDL', digits: 4 },
  BNB: { name: 'BNB', code: 'BNB', digits: 4 },
};

export const getDashboardAssetMeta = (currency) => {
  const code = String(currency || '').toUpperCase();
  return DASHBOARD_ASSET_METADATA[code] || { name: code, code, digits: 4 };
};

export default getDashboardAssetMeta;